// One nudge a session. The viewer has three things that appear on their
// own: the tips (src/ui/tips.js), the Mac wallpaper card
// (src/ui/wallpapercta.js) and the sky alerts card (src/ui/emailcapture.js).
// Whichever shows first takes the session, kept in sessionStorage so a
// reload in the same tab counts too, and the others stay quiet until the
// next one.
//
// The sky alerts card holds the session while it is due (at most once a
// week, src/ui/emailcapture.js): the others wait for it, so the tips, which
// would otherwise be ready first, cannot crowd it out for good. It lets go
// as soon as it is not due (an account already on every event, say).
//
//   nudgeFree('tips')     may this kind show now?
//   markNudge('tips')     it showed: the session is taken
//   holdNudge('capture') / releaseNudge('capture')

export const NUDGE_KEY = 'ss.nudge';

let memory = null; // when sessionStorage is blocked
let held = null;

export function nudgeShown() {
  try { return sessionStorage.getItem(NUDGE_KEY) || memory; } catch { return memory; }
}

export function markNudge(kind) {
  memory = kind;
  try { sessionStorage.setItem(NUDGE_KEY, kind); } catch { /* storage blocked: this page remembers */ }
}

export function nudgeFree(kind) {
  if (nudgeShown()) return false;
  return !held || held === kind;
}

export function holdNudge(kind) { if (!held) held = kind; }
export function releaseNudge(kind) { if (held === kind) held = null; }
export function nudgeHeld() { return held; }

// For tests.
export function resetNudges() {
  memory = null;
  held = null;
  try { sessionStorage.removeItem(NUDGE_KEY); } catch { /* blocked */ }
}
